import { isNullOrEmpty } from "../../../shared/utility";
import { FoxRequestHeader } from "../fox-api/domain/fox-request-header";
import { RentalExtension } from "../models/domain/rental-extension";

export const RentalExtensionRequest = function (data, httpType = "GET") {
  if (!data) data = {};
  this.requestHeader = new FoxRequestHeader({ requestType: httpType });
  this.rentalExtension = new RentalExtension(data.rentalExtension);
  if (!isNullOrEmpty(data?.charges)) {
    this.charges = data.charges || false;
  }
  if (!isNullOrEmpty(data?.details)) {
    this.details = data.details || false;
  }
};
